import { render, staticRenderFns } from "./crosstabRowOnly.vue?vue&type=template&id=d52499c6&scoped=true"
import script from "./crosstabRowOnly.vue?vue&type=script&lang=js"
export * from "./crosstabRowOnly.vue?vue&type=script&lang=js"
import style0 from "./crosstabRowOnly.vue?vue&type=style&index=0&id=d52499c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52499c6",
  null
  
)

export default component.exports